
import React from 'react'

import { verb } from './UrlBar.module.scss'

const Verb = ({ value }) => (
  <div className={ [verb, value].join(' ') }>
    { value }
  </div>
)

export default Verb